import api, { handleAPIErrors } from "shared/api";
import { sortByEntityTypeAndName } from "../../../shared/utilities";

const FETCH_REQUEST = "dashboardSearch/FETCH_REQUEST";
const FETCH_SUCCESS = "dashboardSearch/FETCH_SUCCESS";
const FETCH_FAILURE = "dashboardSearch/FETCH_FAILURE";

const initialState = {
  result: [],
  loaded: false,
  loading: false,
  errors: [],
};

export function fetchRequest(payload = {}) {
  return {
    type: FETCH_REQUEST,
  };
}

export function fetchSuccess(payload) {
  return {
    type: FETCH_SUCCESS,
    payload,
  };
}

export function fetchFailure(errors = []) {
  return {
    type: FETCH_FAILURE,
    errors,
  };
}

export function search(options, cb) {
  return (dispatch) => {
    dispatch(fetchRequest());

    return api("api/v1/dashboard/search", options, {}, true)
      .then((response) => response.json().then((json) => ({ json, response })))
      .then(({ json, response }) => {
        if (!response.ok) {
          return Promise.reject(json);
        }

        dispatch(fetchSuccess(json));
        cb(true);
      })
      .catch((exception) => {
        handleAPIErrors(exception, (errors) => {
          dispatch(fetchFailure(errors));
        });
        cb(false);
      });
  };
}

// Reducer
export default function reducer(state = initialState, action = {}) {
  const { payload, type, errors } = action;

  switch (type) {
    case FETCH_REQUEST:
      return Object.assign({}, state, {
        loading: true,
      });
    case FETCH_SUCCESS:
      return Object.assign({}, state, {
        loading: false,
        loaded: true,
        errors: [],
        result: sortByEntityTypeAndName(payload.result),
      });
    case FETCH_FAILURE:
      return Object.assign({}, state, {
        loaded: false,
        loading: false,
        errors,
      });
    default:
      return state;
  }
}
